export default `Creepy (but totally legal) ways to use Orwellian "big brother"-like methods to track your lists’, prospects’ & leads’ every move.

A cunning little strategy for tracking which exact social media posts (that aren’t directly selling anything) are profitable and which ones aren’t.

A secret way to make sales from people who unsubscribe from your email lists!

Clear & straight-forward tips eCommerce businesses can sometimes use to radically increase sales. 

A very basic automation technique for turning free speaking or podcast appearances into cash in the bank.

Two “Troy approved” & fairly-priced services you can outsource to if you want help setting up your marketing automation, or don’t want to do it yourself.

An almost spooky-effective selling strategy for freelancers & coaches that can potentially make high ticket clients feel (literally) “destined” to want to hire you!

A shockingly simple secret for combating lost recurring sales due to credit card security breaches.

An automation “twist” that can get more people than usual flocking to your webinars... even if your emails promoting those webinars are eaten by spam filters!

The “anti-marketing” method businesses with small lists can use to potentially double or even triple sales.

A clever (and very sneaky) way to profit from prospects who don’t finish watching your video content!

A shrewd way to possibly save hundreds of dollars on your email broadcasting/autoresponder service fees.

A really simple email automation trick for putting affiliates “in heat” to mail for your offers more frequently and make you more sales.

A cheap way to all but eliminate support headaches from customers not getting passwords due to spam filters, duplicate emails, or not seeing your links.

How affiliate marketers can automate bribe, bonus, & premium delivery.

An almost laughably simple way to track ROI from podcast interviews, speaking gigs, radio ads, or anywhere else where people aren’t able to click a link.

A deviously clever automation secret that can help stop cart abandonment dead in its tracks!

How copywriters, coaches, consultants, and other services can sometimes almost completely eliminate chargeback fraud from crooked clients trying to rob you of your hard-earned fees.

A bizarre (yet ingenious) way to potentially build out an online business into 6 or 7 figures over time without needing a "funnel." 

How to price your upsells when selling continuity or subscription based offers.

The real life “churn conspiracy” email platforms engage in every single day... that fools even their biggest fans & most loyal customers! (Troy “names names” while exposing several dirty secrets & telling numerous client horror stories he’s personally experienced with the most popular platforms — including Convertkit, Mailchimp, Drip, Infusionsoft, Hubspot, Aweber, Ontraport, and ActiveCampaign. Most of these companies have a lot of great features & do good work. But it is wise to know what to expect before investing even a penny of your money or second of your time with them.)

An old school direct mail tactic (“adapted” to email automation) that is so powerful it can sometimes turn $50 buyers into $5,000 buyers!

The first and most important thing to do if your email broadcasting and/or shopping cart service ever de-platforms you.

The exact best type of offer to sell when the economy goes to hell in a hand basket.

How to use Zapier with email & cart platforms that it does not integrate with.

A neat little trick shy copywriters & coaches can use to qualify & close high dollar clients.

A "battle tested" way for using self deprecating copy to recapture lost sales.

Why there is no “best” email platform when it comes to delivery.

The single worst email platform to use if you sell to businesses with 500 employees or more.

An inside look at how to migrate your customer list from one platform to another.

The best “first step” email marketing platform to use if you are a brand spanking new marketer, and want to get started fast, and with as little frustration as possible.

An easy automation method that can help you close more deals by “benevolently stalking” clients you send video proposals to.

How to use “Easter egg” pitches in your courses, programs, and content to subtly sell your other products.

Cheap Facebook tricks (straight from the owner of the exact same ad agency Troy uses) for selling more products, building a bigger list, and automating your sales for as little as $5 per day.

Stupid things email marketers do (and sometimes even teach) with images that sometimes make spam filters think you are selling porn!

7 “low hanging fruit” ways almost anyone can use to make more sales from email & marketing automation.

A secret way to convert billing failures into sales.

How to turn your videos into little “marketing spies” constantly reporting back to you on how to better sell your leads.

How to automatically track & recapture billing information without chasing anyone down. 

A 3-email cart abandonment strategy that can potentially give you as much as a 20% bump in sales in 48 hours or less.

How to use “text funnels” to track & remind people about timely trainings & webinars.

How copywriters can use free video funnels to help close more clients
`;
